<template>
    <div  v-pml-block="isLoading" class="bg_load_null">
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
        <div class="card-box p-0 m-0">
            <div class="over_auto">
                <table class="table table-striped table-bordered m-0">
                    <thead>
                        <tr>
                            <th class="t_center w_60"><i class="md-headset-mic"></i></th>
                            <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('number')" :class="isOrderedColumn('number')">N&ordm;</th>
                            <th class="t_center min_w_180">{{ $t('deal') }}</th>
                            <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('issue_date_at')" :class="isOrderedColumn('issue_date_at')">{{ $t('issue_date') }}</th>
                            <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('due_date_at')" :class="isOrderedColumn('due_date_at')">{{ $t('due_date') }}</th>
                            <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('exchange_rate')" :class="isOrderedColumn('exchange_rate')">{{ $t('ex_rate') }}</th>
                            <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('status')" :class="isOrderedColumn('status')">{{ $t('status') }}</th>
                            <th class="t_center max_w_100">{{ $t('value') }}</th>
                            <th class="t_center max_w_80">{{ $t('actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                        <tr v-show="!list.length">
                            <td class="t_center" colspan="9"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import bus from 'utils/events/bus'
    import TableFilters from 'utils/mixins/table-filters'

    export default {
        name: 'QuotationsList',
        components: { PmlItem },
        mixins: [ TableFilters ],
        data () {
            return {
                pagination: {},
                isLoading: false
            }
        },
        created () {
            bus.$on('paginationRefreshQuotations', (data) => { this.pagination = data })
            bus.$on('listLoadingQuotations', (bool) => { this.isLoading = bool })
        },
        destroyed () {
            bus.$off('paginationRefreshQuotations')
            bus.$off('listLoadingQuotations')
        },
        computed: {
            records () {
                return this.pagination.data || []
            }
        },
        methods: {
            fetchList (page = 1) {
                bus.$emit('doFilterQuotations', page)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/quotations/components/List.vue